import React, { useMemo } from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './InadimplenciaChart.css';

const InadimplenciaChart = ({ dados }) => {
  const chartData = useMemo(() => {
    const percentage = Number(dados).toFixed(2);

    const getClassificacao = valor => {
      if (valor < 7)
        return {
          nivel: 'Excelente',
          cor: '#4CAF50',
          icon: 'fas fa-check-circle',
          frase: 'Desempenho exemplar',
        };
      if (valor <= 10)
        return {
          nivel: 'Bom',
          cor: '#8BC34A',
          icon: 'fas fa-thumbs-up',
          frase: 'Situação favorável',
        };
      if (valor <= 15)
        return {
          nivel: 'Regular',
          cor: '#FF9800',
          icon: 'fas fa-exclamation-triangle',
          frase: 'Requer atenção',
        };
      if (valor <= 20)
        return {
          nivel: 'Ruim',
          cor: '#F44336',
          icon: 'fas fa-exclamation',
          frase: 'Ação Imediata',
        };
      return {
        nivel: 'Crítico',
        cor: '#D32F2F',
        icon: 'fas fa-times-circle',
        frase: 'Situação alarmante',
      };
    };

    const classificacao = getClassificacao(percentage);

    const tendencia = percentage <= 15 ? 'redução' : 'aumento';

    return {
      percentage,
      classificacao,
      tendencia,
      corGrafico: percentage > 15 ? '#F44336' : '#4CAF50',
    };
  }, [dados]);

  return (
    <div className="inadimplencia-container">
      <div className="inadimplencia-header">
        <h3 className="inadimplencia-title">Taxa de Inadimplência</h3>
      </div>
      <p className="vm-subtitle">
        Acompanhe a taxa de Inadimplência em tempo real
      </p>

      <div className="chart-section">
        <div className="chart-wrapper">
          <CircularProgressbar
            value={chartData.percentage}
            text={`${chartData.percentage}%`}
            styles={{
              path: {
                stroke: chartData.corGrafico,
                strokeWidth: 8,
                transition: 'stroke-dasharray 0.5s ease 0s',
              },
              trail: {
                stroke: '#f0f0f0',
                strokeWidth: 8,
              },
              text: {
                fill: chartData.classificacao.cor,
                fontSize: '20px',
                fontWeight: 'bold',
              },
            }}
          />
        </div>
      </div>

      <div className="inadimplencia-details">
        <div
          className="status-card-circle"
          style={{ borderLeftColor: chartData.classificacao.cor }}
        >
          <div
            className="status-icon"
            style={{ color: chartData.classificacao.cor }}
          >
            <i className={chartData.classificacao.icon}></i>
          </div>
          <div className="status-content">
            <div
              className="status-level"
              style={{ color: chartData.classificacao.cor }}
            >
              {chartData.classificacao.nivel}
            </div>
            <div className="status-description">
              {chartData.classificacao.frase}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InadimplenciaChart;